// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IeSquareFilledSvg from "@fishx/icons-svg/es/asn/IeSquareFilled";
import FishxIcon from '../components/FishxIcon';

var IeSquareFilled = function IeSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: IeSquareFilledSvg
  }));
};

IeSquareFilled.displayName = 'IeSquareFilled';
export default React.forwardRef(IeSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/IeSquareFilled.js
// module id = 2964
// module chunks = 0